// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/dialogs/components/ComparisonRow.module.css';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const ComparisonRow = observer(
	({
		feature,
		freeValue,
		plutoniumValue,
	}: {
		feature: string;
		freeValue: React.ReactNode;
		plutoniumValue: React.ReactNode;
	}) => (
		<div className={styles.row}>
			<div className={styles.feature}>
				<p className={styles.featureText}>{feature}</p>
			</div>
			<div className={styles.valuesContainer}>
				<div className={styles.freeValue}>{freeValue}</div>
				<div className={styles.plutoniumValue}>{plutoniumValue}</div>
			</div>
		</div>
	),
);
